var Curriculog = Curriculog || {};

Curriculog.UserFlyoutView = (function ($, _, Backbone, UserFlyoutView) {

	var UserFlyoutView = Curriculog.CurriculogView.extend({
		initialize: function (options) {
			this.users = options.users;
			this.roles = options.roles;
			this.entities = options.entities;
			this.userRoles = options.userRoles;
			this.committees = options.committees;
			this.userRights = options.userRights;
			this.agendaAdmins = options.agendaAdmins;
			this.relationships = options.relationships;
			this.currentUserID = parseInt(options.currentUserID);
			this.user = this.users.get(this.currentUserID);
      this.params = options.params;

			var sanitizedUserModel = this.user.getSanitizedModel();

			this.flyoutTitle = new Curriculog.FlyoutTitleView({
				model: this.user,
				title: sanitizedUserModel.name(),
        params: this.params
			});

			this.manageUser = new Curriculog.ManageUserView({
				user: this.user,
			});

			this.manageUserRoles = new Curriculog.ManageUserRolesView({
				roles: this.roles,
				userID: this.currentUserID,
				entities: this.entities,
				userRoles: this.userRoles,
				committees: this.committees,
				agendaAdmins: this.agendaAdmins,
				relationships: this.relationships,
        params: this.params
			});

			this.manageUserRights = new Curriculog.ManageUserRightsView({
				userID: this.currentUserID,
				userRights: this.userRights,
			});

			this.render();
		},

		render: function () {
			this.$el.append(this.flyoutTitle.el);
			this.$el.append(this.manageUser.el);
			this.$el.append(this.manageUserRoles.el);
			this.$el.append(this.manageUserRights.el);
		},

		cleanup: function () {
			this.flyoutTitle.remove();
			this.manageUser.remove();
			this.manageUserRoles.remove();
			this.manageUserRights.remove();
			this.remove();
		},
	});

	return UserFlyoutView;

})($, _, Backbone, Curriculog.UserFlyoutView || {});
